import { gradesList } from "../enums/gradesEnum";

export const ALL_GRADES_MASK = (1 << gradesList.length) - 1;
export const isGradeSelected = (gradeMask, grade) => !!(gradeMask & (1 << (grade.value - 1)));
export const toggleGrade     = (gradeMask, grade) => gradeMask ^ (1 << (grade.value - 1));
export const gradesFromMask  = (mask) => gradesList.filter(g => !!(mask & (1 << (g.value - 1))));
export const gradesToMask    = (grades) => grades.reduce((m, g) => m | (1 << (g.value - 1)), 0);
